import React, { antdUI, useEffect, useState, $api, $tools } from 'react';
import './index.scss';
import { setUserSignIn } from '@/store/actions/userInfo'
import { connect } from 'react-redux';
import { useI18n } from '@/i18n';

let titleP = { fontSize: '16px', color: '#222222', fontWeight: 'Bold', transition: '.3s' },
    titleTime = { color: '#9A9A9A', fontSize: '14px', position: 'absolute', right: '20px', top: '15px' },
    contentP = { paddingLeft: 18, color: '#222222', };

function ProfileNews(props) {
    const { t, localizedField } = useI18n();
    const [ cur, setCur ] = useState("")
    const [ newsData, setNewsData ] = useState([])
    const [ totalDo, setTotalDo ] = useState('')
    const [ currentPage, setCurrentPage ] = useState(1)
    const [ newsTips, setNewsTips ] = useState({ news_trade: 0, news_system: 0 })
    const [ isInt, setIsInt ] = useState(true)
    const [ load, setLoad ] = useState(true);
    const pageSize = 8;
    const { setUserSignIn, userInfo } = props
    useEffect(_ => {
        if (userInfo.steam.steamid && ! userInfo.uid) {
            window.location.href = '/profile/userConfig#login'
        }
    }, [ userInfo ])
    const getUserMessage = async (currentPage) => {
        currentPage && setCurrentPage(currentPage)
        setLoad(true)
        let data = await $api.user.getUserMessage({ type: cur, pageSize, page: currentPage })
        setLoad(false)
        if ($tools.checkResult(data)) {
            setTotalDo(data.data.total)
            setNewsData(data.data.message)
        }
    }
    useEffect(() => {
        let loc_hash = window.location.hash, type;
        if (loc_hash) {
            loc_hash = loc_hash.substr(1);
            if (loc_hash === "system") {
                setCur(2);
                type = 2
            }
            if (loc_hash === `trade`) {
                setCur(1);
                type = 1
            }
            if (! userInfo.uid) return
            $api.user.getUserMessageState().then(res => {
                setNewsTips({ ...res.data })
                if ((type === 1 && res.data.news_trade) || (type === 2 && res.data.news_system)) {
                    $api.user.updateUserMessageState({ type }).then(res => {
                        setNewsTips({ ...res.data });
                        setUserSignIn()
                    });
                }
            })
        } else {
            setCur(1)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    
    useEffect(() => {
        if (isInt) {
            setIsInt(false)
        } else {
            window.location.href = `/profile/news#${ cur === 1 ? `trade` : cur === 2 ? 'system' : "" }`;
            getUserMessage().then()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ cur ])
    return (
        <div className="profile-news">
            <div className="title">
                <h1 onClick={ _ => {
                    setTotalDo(0)
                    setNewsData([])
                    setCur(1);
                    if (userInfo.uid && newsTips.news_trade) {
                        $api.user.updateUserMessageState({ type: 1 }).then(res => {
                            setNewsTips({ ...res.data });
                            setUserSignIn()
                        })
                    }
                } } className={ [ cur === 1 ?
                    `${ newsTips.news_trade ? 'tips' : '' } cur` :
                    newsTips.news_trade ? 'tips' : '' ] }>{ t('交易消息') }</h1>
                <h1 onClick={ _ => {
                    setTotalDo(0)
                    setNewsData([])
                    setCur(2);
                    if (userInfo.uid && newsTips.news_system) {
                        $api.user.updateUserMessageState({ type: 2 }).then(res => {
                            setNewsTips({ ...res.data });
                            setUserSignIn()
                        })
                    }
                } } className={ [ cur === 2 ?
                    `${ newsTips.news_system ? 'tips' : '' } cur` :
                    newsTips.news_system ? 'tips' : '' ] }>{ t('系统消息') }</h1>
            </div>
            
            { load ? <antdUI.Skeleton active/> : <antdUI.Collapse
                bordered={ false } accordion={ true }
            >
                { cur === 2 ? newsData.map((v, i) => {
                    return (
                        <antdUI.Collapse.Panel key={ v.id || i } header={
                            <div className="title">
                                <p className="message-title" style={ titleP }>{ localizedField(v, 'title') }</p>
                                <span style={ titleTime } className="time">{ v.create_time }</span>
                            </div>
                        } className="site-collapse-custom-panel">
                            <div style={ contentP }><p>{ localizedField(v, 'message') }</p></div>
                        </antdUI.Collapse.Panel>
                    )
                }) : newsData.map((v, i) => {
                    return (
                        <div style={ {
                            marginBottom: "20px", display: 'flex',
                            backgroundColor: '#f3f3f3', padding: '8px 0',
                            borderBottom: '1px solid #e9e9e9'
                        } } key={ v.id || i }>
                            <div style={ { width: '80%', paddingRight: "30px" } }>
                                <div style={ contentP }><p>{ localizedField(v, 'message') }</p></div>
                            </div>
                            <div className="flex ait"
                                 style={ { width: '20%', color: '#959595' } }>{ v.create_time }</div>
                        </div>
                    )
                }) }
            </antdUI.Collapse> }
            
            
            <div className="flex jtyct" style={ { marginTop: '20px' } }>
                <antdUI.Pagination
                    onChange={ (currentPage, pageSize) => getUserMessage(currentPage) }
                    hideOnSinglePage={ true }
                    showSizeChanger={ false } current={ currentPage } defaultCurrent={ 1 }
                    total={ totalDo } pageSize={ pageSize }/>
            </div>
        </div>
    )
}


export default connect(function mapStateToProps(state) {
        return {
            userInfo: state.user.userInfo
        }
    },
    function mapDispatchToProps(disatch) {
        return {
            setUserSignIn: () => disatch(setUserSignIn())
        }
    }
)(ProfileNews);
